// extracted by mini-css-extract-plugin
module.exports = {"text":"EduArticlePortableText_text__HeMkl","slide-in-out":"EduArticlePortableText_slide-in-out__pig8i","fade-in-out":"EduArticlePortableText_fade-in-out__MIlSg"};